export const VISIT_DETAILS_UNAVAILABLE_CHAT_INFO_CLICKED =
  'app/containers/Agenda/Detail/PropertyResponsible/VISIT_DETAILS_UNAVAILABLE_CHAT_INFO_CLICKED';
export const VISIT_DETAILS_SECRETARY_WHATSAPP_LINK_CLICKED =
  'app/containers/Agenda/Detail/PropertyResponsible/VISIT_DETAILS_SECRETARY_WHATSAPP_LINK_CLICKED';

export const HIDDEN_CHAT_INFORMATION_LINK_DATA_TEST_ID =
  'HIDDEN_CHAT_INFORMATION_LINK_DATA_TEST_ID';
